import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import { clearItem, getItem, updateItem } from "src/modules/spItems/actions";
import {
  myTaskActionCommentsFilesListName,
  myTaskActionCommentsListName,
  myTaskActionsHistoryListName,
  myTaskActionsListName,
  myTaskActionsStatusesListName,
  myTasksTagsListName,
} from "src/api/config/myTasksActions.config";
import {
  selectGetItemStatus,
  selectItem,
  selectItems,
  selectJustUpdatedItem,
  selectUpdateStatus,
} from "src/modules/spItems/selectors";
import { selectUsers, selectCurrentUser } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import Loading from "src/components/Loading";
import Tabs from "./components/tabs";
import { fieldsInCardAction } from "../../mytasks/addAction/constants";
import {
  addItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import { myTaskMeetingsListName } from "src/api/config/meetings.config";
import { addUsers } from "src/modules/users/actions";
import _ from "lodash";
import Form from "src/components/Form";
import TGButton from "src/components/ui/TGButton";
import HistoryActionCard from "./components/historyActionCard";
import Comments from "src/modules/comments";
import moment from "moment";
import { emailsSender, MTActionCommentsFiles, siteUrl, MT5SInconsistencyListName } from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import {
  myTasksDepartmentsListName,
  myTasksLocationsListName,
  myTasksRegionsListName,
} from "src/api/config/myTasksLists.config";
import { actionsStatus, isStrapi } from "src/api/config/systemSwitch";
import { myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { VPOInconsistences } from "../../vpo/api/vpo.config";
import { gosViolations } from "../../gos/api/config/gos.config";
import { autoCloseModal } from "src/constants";
const { sendEmail } = emailAPI();

const ActionCard = ({
  zIndex,
  setOpen,
  open,
  actionID,
}: {
  actionID: string | null;
  zIndex: number;
  open: boolean;
  setOpen: (b: boolean) => void;
}) => {
  const dispatch = useAppDispatch();
  const actionCard: any = useAppSelector((state) =>
    selectItem(state, myTaskActionsListName)
  );
  const statusGetActionCard = useAppSelector((state) =>
    selectGetItemStatus(state, myTaskActionsListName)
  );
  const statusUpdateActionCard = useAppSelector((state) =>
    selectUpdateStatus(state, myTaskActionsListName)
  );
  const users: any = useAppSelector(selectUsers);
  const [activeTabKey, setActiveTabKey] = useState("card");
  const [listsFields, setListsFields] = useState<any>([]);
  const [fileldsCopyForm, setListsCopyForm] = useState<any>([]);
  const [meetings, setMeetings] = useState<any>([]);
  const [isSelectMeetings, setIsSelectMitings] = useState<any>(false);
  const [isSelectResponsible, setIsSelectResponsible] = useState<any>(false);
  const [formData, setFormData] = useState<any>(null);
  const [copyData, setCopyData] = useState<any>(null);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [checkLoadUsers, setCheckLoadUsers] = useState(false);
  const statuses: any = useAppSelector((state) =>
    selectItems(state, myTaskActionsStatusesListName)
  );
  const currentUser: any = useAppSelector(selectCurrentUser);
  const [returnToWork, setReturnToWork] = useState(false);
  const [copyAction, setCopyAction] = useState(false);
  const [customLoading, setCustomLoading] = useState(true);
  const [redirectToCopy, setRedirectToCopy] = useState(false);
  const [copyActionID, setCopyActionID] = useState<any>(null);
  const idUpdateActionCard = useAppSelector((state) =>
    selectJustUpdatedItem(state, myTaskActionsListName)
  );
  const [viewFlag, setViewFlag] = useState(false);
  const [addAction, setAddAction] = useState(false);
  const locations: any = useAppSelector((state) =>
    selectItems(state, myTasksLocationsListName)
  );
  const departments: any = useAppSelector((state) =>
    selectItems(state, myTasksDepartmentsListName)
  );
  const regions: any = useAppSelector((state) =>
    selectItems(state, myTasksRegionsListName)
  );
  const [linkCardWithAction, setLinkCardWithAction] = useState("");
  const [cardWithActionType, setCardWithActionType] = useState("");
  const [inconsistencesText, setInconsistencesText] = useState("");
  //! поля для действия из 5S Аудита
  const [section5S, setSection5S] = useState("");
  const [questionTitle5S, setQuestionTitle5S] = useState("");
  const [files5S, setFiles5S] = useState<any[]>([]);
  const [valuesSelectExist, setValuesSelectExist] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearItem({ listName: myTaskActionsListName }));
    };
  }, []);

  useEffect(() => {
    if (actionID) {
      dispatch(
        getItem({
          listName: myTaskActionsListName,
          filters: { ID: actionID },
        })
      );
    }
  }, [actionID, activeTabKey]);

  useEffect(() => {
    if (statusGetActionCard === "SUCCESS") {
      setCheckLoadUsers(false);
    }
  }, [statusGetActionCard]);

  useEffect(() => {
    if (!copyAction) {
      setCheckLoadUsers(false);
    } else {
      setIsSelectMitings(false);
      setIsSelectResponsible(false);
    }
  }, [copyAction]);

  useEffect(() => {
    if (
      Object.keys(actionCard).length > 0 &&
      Object.keys(users).length > 0 &&
      !checkLoadUsers &&
      !copyAction
    ) {
      const tempDefaultValues: any = {};
      Object.keys(actionCard).map((key: string) => {
        const field = actionCard[key];
        if (key === "Responsible") {
          tempDefaultValues[key] = [
            {
              label:
                (users[field.Email] && users[field.Email].displayName) ||
                field.Name,
              value:
                (users[field.Email] && users[field.Email].email) || field.Email,
              avatar: (users[field.Email] && users[field.Email].avatar) || null,
              email:
                (users[field.Email] && users[field.Email].email) || field.Email,
            },
          ];
          if (users[field.Email]) {
            setCheckLoadUsers(true);
            setCustomLoading(false);
          }
        } else if (key === "DateForDone") {
          tempDefaultValues[key] = {
            startDate: field.toDate(),
            endDate: field.toDate(),
          };
        } else if (key === "Status") {
          tempDefaultValues[key] = {
            id: field.ID,
            name: field.Title,
            color:
              (isStrapi && actionCard.Status.Metadata.Color) ||
              actionCard["Status_x003a_Color"]["Title"],
          };
        } else if (key === "Meeting") {
          tempDefaultValues[key] = {
            id: field.ID,
            name: field.Title,
          };
        } else if (
          key === "Status_x003a_Color" ||
          key === "AuthorEmail" ||
          key === "Created"
        ) {
          return false;
        } else if (
          key === "OtherFieldsValues" &&
          field &&
          JSON.parse(field).length > 0
        ) {
          JSON.parse(field).forEach((value: any) => {
            Object.keys(value).forEach((key: string) => {
              tempDefaultValues[key] = value[key];
            });
          });
        } else {
          tempDefaultValues[key] = field;
        }
      });
      setDefaultValues({ ...tempDefaultValues });
      setIsSelectMitings({ id: actionCard.Meeting.ID });
      setIsSelectResponsible({ value: actionCard.ResponsibleEmail });
    }
  }, [actionCard, checkLoadUsers, users, statusUpdateActionCard, copyAction]);

  useEffect(() => {
    if (Object.keys(actionCard).length > 0 && meetings.length > 0 && statuses.length > 0) {
      const meetingAction = actionCard.Meeting.Metadata;
      console.log('meetingAction: ', meetingAction);
      console.log('meetings: ', meetings);
      let tempFields: any = [...fieldsInCardAction];
      if (meetingAction && meetingAction.AdditionalFields && meetingAction.AdditionalFields.length > 0) {
        const meetingFields = meetingAction.AdditionalFields;
        meetingFields.forEach((field: any, idx: number) => {
          if (field.type === "location") {
            tempFields = [
              ...tempFields,
              {
                type: "select",
                require: false,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                placeholder: field.value.name,
                width: "w-full",
                options: locations.map((location: any) => {
                  return {
                    id: location.ID,
                    name: location.Title,
                    available: true,
                  };
                }),
              },
            ];
          }
          if (field.type === "department") {
            tempFields = [
              ...tempFields,
              {
                type: "select",
                require: false,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                placeholder: field.value.name,
                width: "w-full",
                options: departments.map((department: any) => {
                  return {
                    id: department.ID,
                    name: department.Title,
                    available: true,
                  };
                }),
              },
            ];
          }
          if (field.type === "sector") {
            tempFields = [
              ...tempFields,
              {
                type: "select",
                require: false,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                placeholder: field.value.name,
                width: "w-full",
                options: regions.map((region: any) => {
                  return {
                    id: region.ID,
                    name: region.Title,
                    available: true,
                  };
                }),
              },
            ];
          }
          if (field.type === "date") {
            tempFields = [
              ...tempFields,
              {
                type: "date",
                require: false,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                placeholder: field.value.name,
                width: "w-full",
              },
            ];
          }
          if (field.type === "employee") {
            tempFields = [
              ...tempFields,
              {
                type: "peoplePicker",
                require: false,
                single: true,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                current: false,
                placeholder: field.value.name,
                width: "w-full",
              },
            ];
          }
          if (field.type === "single") {
            tempFields = [
              ...tempFields,
              {
                type: "select",
                require: false,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                placeholder: field.value.name,
                width: "w-full",
                options: field.options.map((option: any) => {
                  return {
                    id: option.id,
                    name: option.name,
                    available: true,
                  };
                }),
              },
            ];
          }
          if (field.type === "free") {
            tempFields = [
              ...tempFields,
              {
                type: "textArea",
                key: `${field.type}_custom_${idx}`,
                require: false,
                title: field.name,
                placeholder: field.value.name,
                width: "w-full",
              },
            ];
          }
          if (field.type === "many") {
            tempFields = [
              ...tempFields,
              {
                type: "checkbox",
                require: false,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                width: "w-full",
                optionsInputs:
                  (field.options &&
                    field.options.map((option: any) => option.name.trim())) ||
                  [],
              },
            ];
          }
          if (field.type === "grade") {
            tempFields = [
              ...tempFields,
              {
                type: "grade",
                require: false,
                key: `${field.type}_custom_${idx}`,
                title: field.name,
                width: "w-full",
              },
            ];
          }
        });
      }
      if (
        (meetingAction && meetingAction.Owners &&
          meetingAction.Owners.indexOf(currentUser.email) === -1 &&
          meetingAction.Participants &&
          meetingAction.Participants.indexOf(currentUser.email) === -1) ||
        actionCard.Status.ID === actionsStatus.closed ||
        actionCard.Status.ID === actionsStatus.cancel ||
        meetingAction.Statuses === "archive"
      ) {
        for (let i = 0; i < tempFields.length; i++) {
          tempFields[i]["disabled"] = true;
        }
      }
      if (
        (meetingAction && actionCard.Status.ID !== actionsStatus.closed &&
          actionCard.Status.ID !== actionsStatus.cancel &&
          meetingAction.Statuses !== "archive" &&
          meetingAction.Owners &&
          meetingAction.Owners.indexOf(currentUser.email) !== -1) ||
        (meetingAction.Participants &&
          meetingAction.Participants.indexOf(currentUser.email) !== -1)
      ) {
        for (let i = 0; i < tempFields.length; i++) {
          tempFields[i]["disabled"] = false;
        }
      }
      for (let i = 0; i < tempFields.length; i++) {
        if (tempFields[i]["key"] === "Status") {
          console.log('statuses: ', statuses);
          tempFields[i]["options"] = statuses
            .filter(
              (status: any) => status.Color && status.ID !== actionsStatus.old
            )
            .map((status: any) => {
              return {
                id: status.ID,
                name: status.Title,
                color: status.Color,
              };
            });
        }
      }
      if (isSelectMeetings && !isSelectResponsible) {
        for (let i = 0; i < tempFields.length; i++) {
          if (tempFields[i]["key"] === "Responsible") {
            let owners = meetingAction.Owners.split(",").map((owner: string) => {
              owner = owner.trim();
              return {
                value: (users[owner] && users[owner].email) || owner,
                label: (users[owner] && users[owner].displayName) || owner,
                avatar: (users[owner] && users[owner].avatar) || null,
              };
            });
            let participants =
              (meetingAction.Participants &&
                meetingAction.Participants.split(",").map((participant: string) => {
                  participant = participant.trim();
                  return {
                    value:
                      (users[participant] && users[participant].email) ||
                      participant,
                    label:
                      (users[participant] && users[participant].displayName) ||
                      participant,
                    avatar:
                      (users[participant] && users[participant].avatar) || null,
                  };
                })) ||
              [];
            tempFields[i]["options"] = [...owners, ...participants];
          }
        }
      }
      if (!isSelectMeetings && isSelectResponsible) {
        for (let i = 0; i < tempFields.length; i++) {
          if (tempFields[i]["key"] === "Meeting") {
            tempFields[i]["options"] = meetings
              .filter(
                (meeting: any) =>
                  meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                  (meeting.participants &&
                    meeting.participants.indexOf(isSelectResponsible.value) !==
                    -1)
              )
              .filter((item: any) => item.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                  status: item.status,
                };
              });
            if (tempFields[i]["options"].length === 0) {
              tempFields[i]["options"] = [
                {
                  id: 0,
                  name: "Соверщания не найдены",
                  owners: null,
                  participants: null,
                  available: false,
                },
              ];
            }
          }
        }
      }
      if (!isSelectMeetings && !isSelectResponsible) {
        for (let i = 0; i < tempFields.length; i++) {
          if (tempFields[i]["key"] === "Responsible") {
            tempFields[i]["options"] = [];
          }
          if (tempFields[i]["key"] === "Meeting") {
            tempFields[i]["options"] = meetings
              .filter((item: any) => item.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                  status: item.status,
                };
              });
          }
        }
      }
      if (isSelectMeetings && isSelectResponsible) {
        for (let i = 0; i < tempFields.length; i++) {
          if (tempFields[i]["key"] === "Meeting") {
            tempFields[i]["options"] = meetings
              .filter(
                (meeting: any) =>
                  meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                  (meeting.participants &&
                    meeting.participants.indexOf(isSelectResponsible.value) !==
                    -1)
              )
              .filter(
                (meeting: any) =>
                  meeting.id !== isSelectMeetings.id &&
                  meeting.status === "active"
              )
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                  status: item.status,
                };
              });
            if (tempFields[i]["options"].length === 0) {
              tempFields[i]["options"] = [
                {
                  id: 0,
                  name: "Соверщания не найдены",
                  owners: null,
                  participants: null,
                  available: false,
                },
              ];
            }
          }

          if (tempFields[i]["key"] === "Responsible") {
            let owners = meetingAction.Owners.split(",").map((owner: string) => {
              owner = owner.trim();
              return {
                value: (users[owner] && users[owner].email) || owner,
                label: (users[owner] && users[owner].displayName) || owner,
                avatar: (users[owner] && users[owner].avatar) || null,
              };
            });

            let participants =
              (meetingAction.Participants &&
                meetingAction.Participants.split(",").map((participant: string) => {
                  participant = participant.trim();
                  return {
                    value:
                      (users[participant] && users[participant].email) ||
                      participant,
                    label:
                      (users[participant] && users[participant].displayName) ||
                      participant,
                    avatar:
                      (users[participant] && users[participant].avatar) || null,
                  };
                })) ||
              [];
            tempFields[i]["options"] = [...owners, ...participants];
          }
        }
      }
      setListsFields([...tempFields]);
    }
  }, [actionCard, currentUser, JSON.stringify(isSelectMeetings), JSON.stringify(isSelectResponsible), JSON.stringify(meetings), users, JSON.stringify(statuses)]);

  useEffect(() => {
    if (meetings.length === 0) {
      getItemsRequest({
        listName: myTaskMeetingsListName,
        viewFields: [
          "ID",
          "Title",
          "Owners",
          "Participants",
          "Status",
          "AdditionalFields",
        ],
      }).then((result: any) => {
        const tempSelectMeetings = result.items.map((item: any) => {
          return {
            id: item.ID,
            name: item.Title,
            owners: item.Owners,
            participants: item.Participants,
            status: item.Status,
            fields: item.AdditionalFields,
          };
        });
        if (tempSelectMeetings.length > 0) {
          setMeetings([...tempSelectMeetings]);
        }
      });
    }
  }, [meetings]);

  useEffect(() => {
    if (meetings.length > 0) {
      const meeting = meetings.filter(
        (meeting: any) => meeting.id === isSelectMeetings.id
      )[0];
      if (meeting) {
        let usersEmail: any = [];
        usersEmail = (meeting.owners && [
          ...usersEmail,
          ...meeting.owners.split(",").map((owner: string) => owner.trim()),
        ]) || [...usersEmail];
        usersEmail = (meeting.participants && [
          ...usersEmail,
          ...meeting.participants
            .split(",")
            .map((participant: string) => participant.trim()),
        ]) || [...usersEmail];
        usersEmail = _.uniqWith(usersEmail, _.isEqual);
        if (usersEmail.length > 0) {
          dispatch(addUsers(usersEmail));
        }
      }
    }
  }, [isSelectMeetings, meetings]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      const sendData: any = {
        ID: formData["ID"],
        Title: `Update action #${formData["ID"]}`,
        Responsible: formData.Responsible[0]["value"],
        Meeting: formData.Meeting.id,
        Description: formData.Description.trim() + " ",
        ResponsibleEmail: formData.Responsible[0]["value"].toLowerCase().trim(),
        Status: formData.Status.id,
        View: false,
        DateForDone:
          (typeof formData.DateForDone.startDate === "string" &&
            new Date(formData.DateForDone.startDate)) ||
          formData.DateForDone.startDate,
        OtherFieldsValues: JSON.stringify(
          listsFields
            .filter((field: any) => field.key.indexOf("_custom_") !== -1)
            .map((field: any) => {
              return { [field.key]: formData[field.key] };
            })
        ),
      };
      if (
        formData.Status.id === actionsStatus.cancel ||
        formData.Status.id === actionsStatus.closed
      ) {
        sendData["RejectDate"] = new Date();
      }
      const hashTags =
        sendData.Description.match(/(^|\W)(#[а-я\w][а-я\w-]*)/gi) || [];
      setCustomLoading(true);
      if (hashTags.length > 0) {
        getItemsRequest({
          listName: myTasksTagsListName,
          filters: { Title: hashTags },
        }).then((results: any) => {
          const hashTagsInSP = [...results.items];
          let addHashTags: any = [];
          hashTags.forEach((tag: string) => {
            if (
              hashTagsInSP.filter((tagInSP: any) => tagInSP.Title === tag)
                .length === 0
            ) {
              addHashTags = [
                ...addHashTags,
                {
                  Title: tag,
                },
              ];
            }
          });
          if (addHashTags.length > 0) {
            addItemRequest({
              listName: myTasksTagsListName,
              bodyArr: addHashTags,
              body: addHashTags[0],
            }).then(() => {
              setCustomLoading(false);
              dispatch(
                updateItem({
                  listName: myTaskActionsListName,
                  body: sendData,
                  update: true,
                })
              );
            });
          } else {
            setCustomLoading(false);
            dispatch(
              updateItem({
                listName: myTaskActionsListName,
                body: sendData,
                update: true,
              })
            );
          }
        });
      } else {
        setCustomLoading(false);
        dispatch(
          updateItem({
            listName: myTaskActionsListName,
            body: sendData,
            update: true,
          })
        );
      }
    }
  }, [formData]);

  //Добавление истории изменения карточки действия
  useEffect(() => {
    const action_card_data_form = localStorage.getItem("action_card_data_form");
    if (idUpdateActionCard && action_card_data_form) {
      const changesFieldValue = JSON.parse(action_card_data_form);
      localStorage.setItem("action_card_data_form", "");
      if (changesFieldValue && Object.keys(changesFieldValue).length > 0) {
        const historyData = {
          Title: `History action card #${idUpdateActionCard}`,
          Action: idUpdateActionCard,
          History: JSON.stringify(changesFieldValue),
          Status:
            (changesFieldValue.Status && changesFieldValue.Status.new.id) ||
            actionsStatus.edited, //Действие изменено
        };
        addItemRequest({
          listName: myTaskActionsHistoryListName,
          body: historyData,
        });
      }
      if (
        emailsSender &&
        formData.Responsible[0]["value"] !== currentUser.email
      ) {
        const timestamp = moment().unix();
        const sendData: any = {};
        sendData["DateForDone"] =
          (typeof formData.DateForDone.startDate === "string" &&
            new Date(formData.DateForDone.startDate)) ||
          formData.DateForDone.startDate;
        const emailBody = {
          Body: `Здравствуйте ${formData.Responsible[0]["label"]
            },<br/><br/>Сотрудник ${currentUser.displayName
            } обновил действие, за которое Вы являетесь ответственным:<br/><br/><ul><li>Совещание: <a href="${siteUrl}/dashboard/3/meetings?meetingCard=${formData.Meeting.id
            }">${formData.Meeting.name
            }</a></li><li>Описание действия: <a href="${siteUrl}/dashboard/3?actionCard=${idUpdateActionCard}">${formData.Description.trim()}</a></li><li>Срок: ${moment(
              sendData.DateForDone
            )
              .clone()
              .format("DD.MM.YYYY")}</li><li>Статус: ${formData.Status.name
            }</li></ul>`,
          DateToBeSentAt: moment().subtract(12, "hours").toDate(),
          Title: "Мои Задачи | Обновление действия",
          Subject: "Мои Задачи | Обновление действия",
          Recepients: formData.Responsible[0]["value"],
          CheckDoc: String(timestamp),
        };
        Promise.all([sendEmail(emailBody)]).then(() => {
          setFormData(null);
        });
      }
      setAddAction(!addAction);
    }
  }, [idUpdateActionCard]);

  const returnToWorkHandle = (e: any) => {
    e.preventDefault();
    setReturnToWork(false);
    const historyData = {
      Title: `History action card #${actionCard.ID}`,
      Action: actionCard.ID,
      History: JSON.stringify({
        Status: {
          new: { name: "В процессе" },
          old: { name: actionCard.Status.Title },
        },
      }),
      Status: actionsStatus.process, //В процессе
    };
    addItemRequest({
      listName: myTaskActionsHistoryListName,
      body: historyData,
    }).then(() => {
      dispatch(
        updateItem({
          listName: myTaskActionsListName,
          body: {
            ID: actionCard.ID,
            Status: actionsStatus.process,
            DateForDone: new Date(),
          },
          update: true,
        })
      );
    });
  };

  useEffect(() => {
    if (meetings.length > 0) {
      let tempFieldsForm: any = [];
      listsFields.forEach((field) => {
        const tempField: any = { ...field };
        if (
          tempField["key"] === "Meeting" ||
          tempField["key"] === "Responsible"
        ) {
          if (tempField["key"] === "Responsible") {
            tempField["width"] = "w-full";
          }
          if (isSelectMeetings && !isSelectResponsible) {
            const meeting = meetings.filter(
              (meeting: any) => meeting.id === isSelectMeetings.id
            )[0];
            if (tempField["key"] === "Responsible") {
              let owners = meeting.owners.split(",").map((owner: string) => {
                owner = owner.trim();
                return {
                  value: (users[owner] && users[owner].email) || owner,
                  label: (users[owner] && users[owner].displayName) || owner,
                  avatar: (users[owner] && users[owner].avatar) || null,
                };
              });

              let participants =
                (meeting.participants &&
                  meeting.participants.split(",").map((participant: string) => {
                    participant = participant.trim();
                    return {
                      value:
                        (users[participant] && users[participant].email) ||
                        participant,
                      label:
                        (users[participant] &&
                          users[participant].displayName) ||
                        participant,
                      avatar:
                        (users[participant] && users[participant].avatar) ||
                        null,
                    };
                  })) ||
                [];

              tempField["options"] = [...owners, ...participants];
            }
          }
          if (!isSelectMeetings && isSelectResponsible) {
            if (tempField["key"] === "Meeting") {
              tempField["options"] = meetings
                .filter(
                  (meeting: any) =>
                    meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                    (meeting.participants &&
                      meeting.participants.indexOf(
                        isSelectResponsible.value
                      ) !== -1)
                )
                .filter((item: any) => item.status === "active")
                .map((item: any) => {
                  return {
                    id: item.id,
                    name: item.name,
                    owners: item.owners,
                    participants: item.participants,
                    status: item.status,
                  };
                });
              if (tempField["options"].length === 0) {
                tempField["options"] = [
                  {
                    id: 0,
                    name: "Соверщания не найдены",
                    owners: null,
                    participants: null,
                    available: false,
                  },
                ];
              }
            }
          }
          if (!isSelectMeetings && !isSelectResponsible) {
            if (tempField["key"] === "Responsible") {
              tempField["options"] = [];
            }
            if (tempField["key"] === "Meeting") {
              tempField["options"] = meetings
                .filter((item: any) => item.status === "active")
                .map((item: any) => {
                  return {
                    id: item.id,
                    name: item.name,
                    owners: item.owners,
                    participants: item.participants,
                    status: item.status,
                  };
                });
            }
          }
          if (isSelectMeetings && isSelectResponsible) {
            const meeting = meetings.filter(
              (meeting: any) => meeting.id === isSelectMeetings.id
            )[0];
            if (tempField["key"] === "Meeting") {
              tempField["options"] = meetings
                .filter(
                  (meeting: any) =>
                    meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                    (meeting.participants &&
                      meeting.participants.indexOf(
                        isSelectResponsible.value
                      ) !== -1)
                )
                .filter(
                  (meeting: any) =>
                    meeting.id !== isSelectMeetings.id &&
                    meeting.status === "active"
                )
                .map((item: any) => {
                  return {
                    id: item.id,
                    name: item.name,
                    owners: item.owners,
                    participants: item.participants,
                    status: item.status,
                  };
                });
              if (tempField["options"].length === 0) {
                tempField["options"] = [
                  {
                    id: 0,
                    name: "Соверщания не найдены",
                    owners: null,
                    participants: null,
                    available: false,
                  },
                ];
              }
            }

            if (tempField["key"] === "Responsible") {
              let owners = meeting.owners.split(",").map((owner: string) => {
                owner = owner.trim();
                return {
                  value: (users[owner] && users[owner].email) || owner,
                  label: (users[owner] && users[owner].displayName) || owner,
                  avatar: (users[owner] && users[owner].avatar) || null,
                };
              });

              let participants =
                (meeting.participants &&
                  meeting.participants.split(",").map((participant: string) => {
                    participant = participant.trim();
                    return {
                      value:
                        (users[participant] && users[participant].email) ||
                        participant,
                      label:
                        (users[participant] &&
                          users[participant].displayName) ||
                        participant,
                      avatar:
                        (users[participant] && users[participant].avatar) ||
                        null,
                    };
                  })) ||
                [];

              tempField["options"] = [...owners, ...participants];
            }
          }
          tempField["disabled"] = false;
          tempFieldsForm = [...tempFieldsForm, tempField];
        }
      });
      setListsCopyForm([...tempFieldsForm]);
    }
  }, [listsFields, meetings, isSelectMeetings, isSelectResponsible]);

  useEffect(() => {
    if (copyData && Object.keys(copyData).length > 0) {
      setCopyAction(false);
      setCustomLoading(true);
      const sendData = {
        Title: `Copy action # ${actionCard.ID}`,
        Responsible: copyData.Responsible[0]["value"],
        Meeting: copyData.Meeting.id,
        Description: actionCard.Description,
        Status: actionsStatus.notStart,
        AuthorEmail: currentUser.email.toLowerCase().trim(),
        ResponsibleEmail: copyData.Responsible[0]["value"].toLowerCase().trim(),
        DateForDone: actionCard.DateForDone.toDate(),
      };
      addItemRequest({ listName: myTaskActionsListName, body: sendData }).then(
        (copyActionIDAdded) => {
          const historyData = [
            {
              Title: `History action card copy #${actionID}`,
              History: JSON.stringify({
                Meeting: {
                  new: { name: copyData.Meeting.name },
                  old: { name: "" },
                },
              }),
              Action: actionID,
              Status: actionsStatus.copy, //Действие скопировано
            },
            {
              Title: `History action card copy #${copyActionIDAdded}`,
              Action: copyActionIDAdded,
              Status: actionsStatus.created, //Действие создано
            },
          ];
          addItemRequest({
            listName: myTaskActionsHistoryListName,
            bodyArr: historyData,
            body: historyData[0],
          }).then(() => {
            setCopyData(null);
            setCustomLoading(false);
            setCopyActionID(copyActionIDAdded);
            setRedirectToCopy(true);
          });
        }
      );
    }
  }, [copyData]);

  useEffect(() => {
    if (
      Object.keys(actionCard).length > 0 &&
      actionCard.ResponsibleEmail &&
      currentUser.email &&
      actionCard.ResponsibleEmail.indexOf(currentUser.email) !== -1 &&
      !viewFlag
    ) {
      setViewFlag(true);
      if (!actionCard.View) {
        updateItemRequest({
          listName: myTaskActionsListName,
          body: { ID: actionCard.ID, View: true },
        });
      }
    }
  }, [actionCard, viewFlag, currentUser]);

  useEffect(() => {
    if (
      Object.keys(actionCard).length > 0 &&
      (actionCard.Status.ID === actionsStatus.notStart ||
        actionCard.Status.ID === actionsStatus.process) &&
      actionCard.DateForDone.clone().startOf("day").unix() <
      moment(new Date()).clone().startOf("day").unix()
    ) {
      dispatch(
        updateItem({
          listName: myTaskActionsListName,
          body: { ID: actionCard.ID, Status: actionsStatus.old },
          update: true,
        })
      );
      if (emailsSender) {
        const timestamp = moment().unix();
        const emailBody = {
          Body: `Здравствуйте ${users[actionCard["ResponsibleEmail"]] &&
            users[actionCard["ResponsibleEmail"]]["displayName"]
            },<br/><br/>Примите к сведению, что действие, где вы являетесь ответственным, перешло в статус «Просрочено»:<br/><br/><ul><li>Совещание: <a href="${siteUrl}/dashboard/3/meetings?meetingCard=${actionCard.Meeting.ID
            }">${actionCard.Meeting.Title
            }</a></li><li>Описание действия: <a href="${siteUrl}/dashboard/3?actionCard=${actionCard.ID
            }">${actionCard.Description
            }</a></li><li>Срок: ${actionCard.DateForDone.clone().format(
              "DD.MM.YYYY"
            )}</li></ul>`,
          DateToBeSentAt: moment().subtract(12, "hours").toDate(),
          Title: "Мои Задачи | Просрочено действие",
          Subject: "Мои Задачи | Просрочено действие",
          Recepients: actionCard["ResponsibleEmail"],
          CheckDoc: String(timestamp),
        };
        Promise.all([sendEmail(emailBody)]);
      }
    }
    if (
      Object.keys(actionCard).length > 0 &&
      actionCard.Status.ID === actionsStatus.old &&
      actionCard.DateForDone.clone().startOf("day").unix() >=
      moment(new Date()).clone().startOf("day").unix()
    ) {
      dispatch(
        updateItem({
          listName: myTaskActionsListName,
          body: { ID: actionCard.ID, Status: actionsStatus.process },
          update: true,
        })
      );
    }
    if (Object.keys(actionCard).length > 0 && actionCard.ImportantHashTag) {
      const hashTag = actionCard.ImportantHashTag;
      if (hashTag.indexOf("5Почему") !== -1) {
        setLinkCardWithAction(
          `${siteUrl}/dashboard/3/5-whys?5WayCard=${hashTag
            .split("_")
          [hashTag.split("_").length - 1]}`
        );
        setCardWithActionType("FiveWhy");
      }
      if (hashTag.indexOf("Отчет_об_отклонениях") !== -1) {
        if (hashTag.indexOf("A") !== -1) {
          setLinkCardWithAction(
            `${siteUrl}/dashboard/3/deviation-reports?deviationCard=${hashTag
              .split("_")
            [hashTag.split("_").length - 1].replace("A", "")}`
          );
          setCardWithActionType("deviationCard");
        } else {
          getItemsRequest({
            listName: myTasksSDCA5WayListName,
            filters: { ID: hashTag.split("_")[hashTag.split("_").length - 1] },
          }).then((results) => {
            const sdcaItems = [...results.items];
            const idCardWithAction = sdcaItems[0]._x0035_Way.get_lookupId();
            setLinkCardWithAction(
              `${siteUrl}/dashboard/3/deviation-reports?deviationCard=${idCardWithAction}`
            );
            setCardWithActionType("deviationCard");
          });
        }
      }
      if (hashTag.indexOf("ПоведенческийАудит") !== -1) {
        const idCardWithAction =
          hashTag.split("_")[hashTag.split("_").length - 1];
        setLinkCardWithAction(
          `${siteUrl}/dashboard/3/behavioral-audit?auditCard=${idCardWithAction}`
        );
        setCardWithActionType("auditCard");
      }
      if (hashTag.indexOf("несоответствие") !== -1) {
        const idCardWithAction =
          hashTag.split("_")[hashTag.split("_").length - 1];
        setLinkCardWithAction(
          `${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${idCardWithAction}`
        );
        setCardWithActionType("incidentCard");
      }
      if (hashTag.indexOf("security") !== -1) {
        const idCardWithAction =
          hashTag.split("_")[hashTag.split("_").length - 1];
        setLinkCardWithAction(
          `${siteUrl}/dashboard/3/incidents-security?securityCard=${idCardWithAction}`
        );
        setCardWithActionType("securityCard");
      }
      if (hashTag.indexOf("OWD") !== -1) {
        const idCardWithAction =
          hashTag.split("_")[hashTag.split("_").length - 1];
        setLinkCardWithAction(
          `${siteUrl}/dashboard/1/reports/4?notificationCard=${idCardWithAction}`
        );
        setCardWithActionType("notificationCard");
      }
      if (hashTag.indexOf("VPO") !== -1) {
        getItemsRequest({
          listName: VPOInconsistences,
          filters: { ID: hashTag.split("_")[hashTag.split("_").length - 1] },
        }).then((results) => {
          const inconsistences = [...results.items];
          setInconsistencesText(inconsistences[0].Inconsistences);
          const idCardWithAction = inconsistences[0].IdVPOactions;
          setLinkCardWithAction(
            `${siteUrl}/dashboard/6?actionCardVPO=${idCardWithAction}`
          );
          setCardWithActionType("actionCardVPO");
        });
      }
      if (hashTag.indexOf("5SАудит") !== -1) {
        getItemsRequest({
          listName: MT5SInconsistencyListName,
          filters: { ID: Number(hashTag.split("_")[hashTag.split("_").length - 1]) },
          populateFields: [{ Answer: ["Cards", "Question"] }, { Files: ["File"] }],
        }).then((results) => {
          const inc: any = results.items[0];
          if (!inc) return;
          const answer = inc.Answer;
          const cardId = answer?.Cards?.id;
          const questionId = answer?.Question?.id;
          setInconsistencesText(inc.Description || "");
          setSection5S(answer?.Question?.Section || "");
          setQuestionTitle5S(answer?.Question?.Title || "");
          setFiles5S(Array.isArray(inc.Files) ? inc.Files : []);
          if (cardId && questionId) {
            setLinkCardWithAction(
              `${siteUrl}/dashboard/3/5S-audit?actionCard5S=${cardId}&questionId=${questionId}`
            );
          }
          setCardWithActionType("actionCard5S");
        });
      }
      //ViolationsGosInActionCardListName - заменить когда переведут на страпи. Убрать anySite
      if (hashTag.indexOf("Предписание") !== -1) {
        getItemsRequest({
          anySite: "https://supplyportal.abinbevefes.com/gos/",
          listName: gosViolations,
          filters: { ID: hashTag.split("_")[hashTag.split("_").length - 1] },
        }).then((results) => {
          const violations = [...results.items];
          const idCardWithAction = violations[0].ParentFormId;
          setLinkCardWithAction(
            `${siteUrl}/dashboard/4?prescriptionCard=${idCardWithAction}`
          );
          setCardWithActionType("prescriptionCard");
        });
      }
      if (hashTag.indexOf("Лицензии") !== -1) {
        const idCardWithAction =
          hashTag.split("_")[hashTag.split("_").length - 1];
        setLinkCardWithAction(
          `${siteUrl}/dashboard/4/licenses?licenseCard=${idCardWithAction}`
        );
        setCardWithActionType("licenseCard");
      }
      if (hashTag.indexOf("GOP") !== -1) {
        const idCardWithAction =
          hashTag.split("_")[hashTag.split("_").length - 1];
        setLinkCardWithAction(
          `${siteUrl}/dashboard/2?actionCardGOP=${idCardWithAction}`
        );
        setCardWithActionType("actionCardGOP");
      }
      if (hashTag.indexOf("чек-лист") !== -1) {
        const idCardWithAction =
          hashTag.split("_")[hashTag.split("_").length - 1];
        setLinkCardWithAction(
          `${siteUrl}/dashboard/3?taskCard=${idCardWithAction}`
        );
        setCardWithActionType("taskCard");
      }
    }
  }, [actionCard]);

  useEffect(() => {
    console.log('[listsFields state]', listsFields);
  }, [listsFields]);

  return (
    <DrawerComponent
      zIndex={zIndex}
      open={open}
      toggleDrawer={setOpen}
      percentage="79"
    >
      <FlexRow className="justify-between p-10">
        <h1 className="text-black">Действие</h1>
        {Object.keys(actionCard).length > 0 && (
          <FlexRow className="items-center gap-2">
            <UserAvatar
              avatar={
                users[actionCard["AuthorEmail"].trim().toLowerCase()] &&
                users[actionCard["AuthorEmail"].trim().toLowerCase()]["avatar"]
              }
              shortName={
                users[actionCard["AuthorEmail"].trim().toLowerCase()] &&
                users[actionCard["AuthorEmail"].trim().toLowerCase()][
                "shortName"
                ]
              }
              displayName={
                users[actionCard["AuthorEmail"].trim().toLowerCase()] &&
                users[actionCard["AuthorEmail"].trim().toLowerCase()][
                "displayName"
                ]
              }
              email={
                users[actionCard["AuthorEmail"].trim().toLowerCase()] &&
                users[actionCard["AuthorEmail"].trim().toLowerCase()]["email"]
              }
            />
            <FlexCol>
              <span>
                {users[actionCard["AuthorEmail"].trim().toLowerCase()] &&
                  users[actionCard["AuthorEmail"].trim().toLowerCase()][
                  "displayName"
                  ]}
              </span>
              <span className="text-[#637381] text-xs">
                Дата: {actionCard["Created"].format("DD.MM.YYYY")}
              </span>
            </FlexCol>
          </FlexRow>
        )}
      </FlexRow>
      <Tabs
        actionID={actionID}
        activeTabKey={activeTabKey}
        setActiveTabKey={setActiveTabKey}
      />
      {((statusGetActionCard === "LOADING" ||
        statusGetActionCard === "IDLE" ||
        statusUpdateActionCard === "LOADING" ||
        customLoading) && (
          <div className="flex items-center justify-center w-full p-10">
            <Loading />
          </div>
        )) ||
        (activeTabKey === "card" && (
          <div className="flex p-10">
            <Form
              type="action_card"
              setFormData={setFormData}
              fieldsForm={[...listsFields]}
              defaultValues={defaultValues}
              setIsSelectMitings={setIsSelectMitings}
              setIsSelectResponsible={setIsSelectResponsible}
              setOpenCancelAddCard={setReturnToWork}
              openCancelAddCard={returnToWork}
              copyAction={copyAction}
              setCopyAction={setCopyAction}
              meetingAction={Object.keys(actionCard).length > 0 && actionCard.Meeting.Metadata || null}
              linkCardWithAction={linkCardWithAction}
              cardWithActionType={cardWithActionType}
              inconsistencesText={inconsistencesText}
              section5S={section5S}
              questionTitle5S={questionTitle5S}
              files5S={files5S}
            />
          </div>
        )) ||
        (activeTabKey === "comments" && (
          <Comments
            history={true}
            zIndex={zIndex + 50}
            IDCard={actionCard.ID}
            listComments={myTaskActionCommentsListName}
            listFilesComments={myTaskActionCommentsFilesListName}
            strapiParams={MTActionCommentsFiles}
            field="Action"
            customClass="p-10 mb-5 w-full"
          />
        )) ||
        (activeTabKey === "history" && (
          <div className="flex p-10">
            <HistoryActionCard actionID={actionCard.ID} />
          </div>
        ))}
      {/*Модалка для подтверждения возврата в работу */}
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px p-10 gap-5 flex"
        open={returnToWork}
        toggleDialog={setReturnToWork}
      >
        <h2>Подтвердите действие</h2>

        <p>Вы уверены, что хотите вернуть в работу действие?</p>
        <div className="w-full border-t" />
        <footer className="flex justify-between w-full">
          <TGButton
            color="white"
            onClick={(e) => setReturnToWork(!returnToWork)}
          >
            Отмена
          </TGButton>
          <TGButton color="bluedark" onClick={(e) => returnToWorkHandle(e)}>
            Вернуть действие в работу
          </TGButton>
        </footer>
      </Modal>
      {/*Модалка для подтверждения копирования действия */}
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px flex gap-5 p-10 max-w-[600px]"
        open={copyAction}
        toggleDialog={setCopyAction}
      >
        <h2>Подтвердите действие</h2>

        <Form
          type="action_card_copy"
          setFormData={setCopyData}
          fieldsForm={[...fileldsCopyForm].reverse()}
          setIsSelectMitings={setIsSelectMitings}
          setIsSelectResponsible={setIsSelectResponsible}
          copyAction={copyAction}
          setCopyAction={setCopyAction}
        />
      </Modal>
      {/*Модалка открытия копии действия в новой вкладке */}
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px flex gap-5 p-10"
        open={redirectToCopy}
        toggleDialog={setRedirectToCopy}
      >
        <h2>Действие скопировано!</h2>

        <p>Вы хотите открыть действие в новой вкладке?</p>
        <div className="w-full border-t" />
        <footer className="flex justify-between w-full">
          <TGButton color="white" onClick={(e) => setRedirectToCopy(false)}>
            Не открывать
          </TGButton>
          <a
            className="text-white bg-darkblue hover:bg-[#010b69] text-base lg:px-6 py-3 sm:px-4"
            href={`${siteUrl}/dashboard/3?actionCard=${copyActionID}`}
            target="_blank"
          >
            Открыть в новой вкладке
          </a>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={addAction}
        toggleDialog={setAddAction}
        autoClose={autoCloseModal}
        onAutoClose={() => {
          setAddAction(!addAction)
        }}
      >
        <header className="px-10 pb-4">
          <h2>Вы успешно сохранили действие</h2>
        </header>

        <div className="px-10 py-5">
          <p>Действие сохранено со всеми изменениями</p>
        </div>

        <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="bluedark" onClick={(e) => setAddAction(!addAction)}>
            Закрыть
          </TGButton>
        </footer>
      </Modal>
    </DrawerComponent>
  );
};

export default ActionCard;
